import { connect } from 'react-redux'
import OverviewLayout from 'pages/mwoverview/Main'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'
import { hasContentType } from 'redux/actions/user'
import { MARKETS_ACCESS_CONTENT } from 'constants/access-roles'

const mapStateToProps = (state) => ({
  browser: state.layout.browser,
  isLogged: state.user.isLogged,
  hasMarketsAccess: hasContentType(state.user.accessRoles, MARKETS_ACCESS_CONTENT)
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen)),
  setUserRolesModalIsOpen: isOpen => dispatch(setUserRolesModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(OverviewLayout)
